<template>
    <!--醫師科別掛號-->
    <v-flex  class="xs12 sm12 md12 lg12 pl-4 pr-4">
        <v-progress-linear v-show="docLoading" :indeterminate="docLoading"></v-progress-linear> <!--載入進度條 -->
        <v-expansion-panels focusable  v-if="selfDiv=='OFF'">
            <v-expansion-panel
                    style="padding: 0px"
                    v-for="(item,index) in divList"
                    :key="index"
                    @click="axios_getDoctorListData(item.docCode)"
            >
                <v-expansion-panel-header >

                    <v-row no-gutters>
                        <v-col
                                cols="12"
                                class="text--secondary"
                        >
                            <v-fade-transition leave-absolute>
                                <v-row
                                        no-gutters
                                        style="width: 100%"
                                >
                                    <v-col cols="12" class="row wrap">
                                        <div class="expandDivTitleFront"></div>
                                        <div class="expandDivTitle text-center">{{item.docCode}} <br/>  {{item.codeName}} </div>
                                        <p v-html="item.hospDoc" :class="['pl-2 expandDivSubTitle',$vuetify.breakpoint.smAndDown?'mt-6':'mt-0']" style="white-space: pre-line"></p>
                                    </v-col>
                                    <!--<v-col cols="12" >-->
                                      <!---->
                                    <!--</v-col>-->
                                </v-row>
                            </v-fade-transition>
                        </v-col>
                    </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>

                    <v-row   class="xs12 sm12 md12 lg12 ">
                        <v-col  cols="12" sm="12" md="6" lg="4" v-for="(item,index) in doctorList" :key="index" >
                            <v-layout
                                    class="mx-auto divHospDoc row wrap"
                                    max-width="344"

                            >
                                <v-flex xs12 sm12 md12 lg12 >
                                    <v-flex row wrap>
                                        <div class="headline text-left hospDocHeader ">{{item.empName}}</div>
                                        <v-btn  class="ml-2 regBtn" @click="regDocClick(item)">預約掛號</v-btn>
                                    </v-flex>

                                </v-flex>

                                <v-flex xs12 sm12 md12 lg12 >
                                    <!--<v-list-item-content>-->
                                        <div style="white-space: pre-line" v-html="item.empExper"></div> <!--經歷-->
                                        <div style="white-space: pre-line" v-html="item.empDoc"></div> <!--介紹-->
                                    <!--</v-list-item-content>-->
                                </v-flex>

                            </v-layout>
                        </v-col>

                    </v-row>

                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <!--自定義科別-->
        <v-expansion-panels focusable  v-else>
            <v-expansion-panel
                    style="padding: 0px"
                    v-for="(item,index) in divList"
                    :key="index"
                    @click="axios_getDoctorListData(item.value3)"
            >
                <v-expansion-panel-header >

                    <v-row no-gutters>
                        <v-col
                                cols="12"
                                class="text--secondary"
                        >
                            <v-fade-transition leave-absolute>
                                <v-row
                                        no-gutters
                                        style="width: 100%"
                                >
                                    <v-col cols="12" class="row wrap">
                                        <div class="expandDivTitleFront"></div>
                                        <div class="expandDivTitle text-center">{{item.value1}} <br/>  {{item.value2}} </div>
                                        <p v-html="item.hospDoc" :class="['pl-2 expandDivSubTitle',$vuetify.breakpoint.smAndDown?'mt-6':'mt-0']" style="white-space: pre-line"></p>
                                    </v-col>
                                    <!--<v-col cols="12" >-->
                                    <!---->
                                    <!--</v-col>-->
                                </v-row>
                            </v-fade-transition>
                        </v-col>
                    </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>

                    <v-row   class="xs12 sm12 md12 lg12 ">
                        <v-col  cols="12" sm="12" md="6" lg="4" v-for="(item,index) in doctorList" :key="index" >
                            <v-layout
                                    class="mx-auto divHospDoc row wrap"
                                    max-width="344"

                            >
                                <v-flex xs12 sm12 md12 lg12 >
                                    <v-flex row wrap>
                                        <div class="headline text-left hospDocHeader ">{{item.empName}}</div>
                                        <v-btn  class="ml-2 regBtn" @click="regDocClick(item)">預約掛號</v-btn>
                                    </v-flex>

                                </v-flex>

                                <v-flex xs12 sm12 md12 lg12 >
                                    <!--<v-list-item-content>-->
                                    <div style="white-space: pre-line" v-html="item.empExper"></div> <!--經歷-->
                                    <div style="white-space: pre-line" v-html="item.empDoc"></div> <!--介紹-->
                                    <!--</v-list-item-content>-->
                                </v-flex>

                            </v-layout>
                        </v-col>

                    </v-row>

                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>


        <!--彈跳式 載入視窗-->
        <!--<v-dialog-->
                <!--v-model="docLoading"-->
                <!--hide-overlay-->
                <!--persistent-->
                <!--width="300"-->
        <!--&gt;-->
            <!--<v-card-->
                    <!--color="primary"-->
                    <!--dark-->
            <!--&gt;-->
                <!--<v-card-text>-->
                    <!--查詢中，請稍後-->
                    <!--<v-progress-linear-->
                            <!--indeterminate-->
                            <!--color="white"-->
                            <!--class="mb-0"-->
                    <!--&gt;</v-progress-linear>-->
                <!--</v-card-text>-->
            <!--</v-card>-->
        <!--</v-dialog>-->

    </v-flex>
</template>

<script>
    export default {
        name: "DocDivRegSearch",
        data() {
            return {
                divList:[],
                divLoading:false,
                doctorList: [],
                docLoading:false,
                selfDiv:'OFF',
                clinicTheme:'ClinicA',

            }
        },
        created(){
            // this.axios_getDivAllData();//查詢某院區全部科別介紹
            this.axios_getRegCondSelfDiv();//查詢是否使用自定義類別
            this.axios_getSysTheme(); // 查詢系統樣式
        },
        methods:{
            regDocClick(item){
              this.$router.push({name: this.clinicTheme, params:{divCode:item.divNo}, query: {empNo:item.empNo}});
            },
            axios_getDivAllData (){ //查詢某院區全部科別介紹
                this.divList = [];
                this.divLoading = true;
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "hospdoc/datasearch/primarykeys/"+zone+"/DIV/ALL";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.divList = response.data.resultSet;
                        this.divLoading = false;
                    }else{
                        this.divList = [];
                        this.divLoading = false;
                    }
                }).catch(error =>  {
                    this.divLoading = false;
                    try {
                        console.log(error.response.data.status);
                        this.divList = [];
                    } catch(err) {
                        this.divList = [];
                    }
                });
            },
            //查詢自訂義類別科別介紹 1100112
            // http://172.16.1.72:8080/iRegaSrv/rest/hospdoc/datasearch/primarykeys/A/SELFDIV/AL
            axios_getSelfDivAllData (){ //查詢某院區全部自訂義科別
                this.divList = [];
                this.divLoading = true;
                let url = '';
                // let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                // url = this.$store.state.AppSetting.backSrvUrl + "hospdoc/datasearch/primarykeys/"+zone+"/SELFDIV/ALL";
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/SELFDIV/ALL";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.divList = response.data.resultSet;
                        for(let i in this.divList){
                            this.axios_getSelfDivByDivCode(this.divList[i].value1,i);
                        }
                        this.divLoading = false;
                    }else{
                        this.divList = [];
                        this.divLoading = false;
                    }
                }).catch(error =>  {
                    this.divLoading = false;
                    try {
                        console.log(error.response.data.status);
                        this.divList = [];
                    } catch(err) {
                        this.divList = [];
                    }
                });
            },
            axios_getSelfDivByDivCode (divCode,index){ //查詢自訂義科別介紹 hospdoc/datasearch/primarykeys/A/SELFDIV
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "hospdoc/datasearch/primarykeys/"+zone+"/SELFDIV/"+divCode;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.$set(this.divList[index], 'hospDoc', response.data.resultSet[0].hospDoc); //設定positionId List
                    }else{
                        this.divList[index].hospDoc = '';
                    }
                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.divList[index].hospDoc = '';
                    } catch(err) {
                        this.divList[index].hospDoc = '';
                    }
                });
            },
            //科別醫師簡介
            axios_getDoctorListData (divNo){ //查詢醫師簡介全部清單
                this.docLoading = true;
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "iregdoctor/datasearch/bydivno/"+zone+"/"+divNo;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.doctorList = response.data.resultSet;
                        this.docLoading = false;
                    }else{
                        this.doctorList = [];
                        this.docLoading = false;
                    }
                }).catch(error =>  {
                    this.docLoading = false;
                    try {
                        console.log(error.response.data.status);
                        this.doctorList = [];
                    } catch(err) {
                        this.doctorList = [];
                    }
                });
            },
            //http://172.16.1.72:8080/iRegaSrv/rest/iregsetting/datasearch/bygroupidcode/SELFDIV/ALL  //自訂義科別
            //http://172.16.1.72:8080/iRegaSrv/rest/iregsetting/datasearch/bygroupidcode/SELFDIV/ALL  REGCOND	SELF_DIV	ON
            axios_getRegCondSelfDiv (){ //是否使用自訂義科別 查詢設定檔
                let url = '';
                    url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/REGCOND/SELF_DIV";

                    this.$http.get(url).then(response =>{
                        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                            this.selfDiv = response.data.resultSet[0].value1;
                            if(this.selfDiv=='ON'){
                                this.axios_getSelfDivAllData();
                            }else {
                                this.axios_getDivAllData();
                            }


                        }else{
                            this.selfDiv = 'OFF'
                            this.axios_getDivAllData();
                        }


                    }).catch(error =>  {
                        try {
                            this.selfDiv = 'OFF'
                            console.log(error.response.data.status);

                        } catch(err) {
                            this.selfDiv = 'OFF'
                        }
                        this.axios_getDivAllData();

                    });

            },
            //查詢樣式 1100113
            axios_getSysTheme (){ //查詢樣式theme設定檔
                let url = '';
                this.clinicTheme = 'ClinicA';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/THEME";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.clinicTheme = response.data.resultSet[0].value3;

                    }else{
                        this.clinicTheme = 'ClinicA';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.clinicTheme = 'ClinicA';
                    } catch(err) {
                        this.clinicTheme = 'ClinicA';
                    }

                });


            },
        }
    }
</script>

<style scoped>

</style>